module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="nei-banner">\r\n    <img src="' +
((__t = ( require('./images/serve-banner.jpg') )) == null ? '' : __t) +
'" />\r\n    <div class="title">服务支持</div>\r\n</div>';

}
return __p
}